import type { ReactNode } from "react";
import cx from "ui/cx";
import Label from "ui/forms/Label";
import styles from "./InputGridLabel.module.scss";

export interface InputGridLabelProps extends React.HTMLAttributes<HTMLDivElement> {
  text: ReactNode;
  tooltip?: ReactNode;
  required?: boolean;
  secondaryText?: ReactNode;
  htmlFor?: string;
  disabled?: boolean;
}

export default function InputGridLabel({
  text,
  tooltip,
  required = false,
  secondaryText,
  htmlFor,
  className,
  disabled = false,
  ...props
}: InputGridLabelProps) {
  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      <Label htmlFor={htmlFor} required={required} tooltip={tooltip} disabled={disabled}>
        {text}
      </Label>
      {secondaryText && (
        <div className={styles.labelSecondary} data-testid="label-secondary-text">
          {secondaryText}
        </div>
      )}
    </div>
  );
}
